
            <div class="content-wrapper">
                <div class="page-header">
                    <h3 class="page-title" style="cursor: context-menu;">
                        <span class="page-title-icon bg-gradient-success text-white mr-2">
                            <i class="mdi mdi-file-document menu-icon"></i>
                        </span> รายงานผู้สอบบัญชี
                    </h3>
                    <nav aria-label="breadcrumb">
                        <button class="btn btn-inverse-success btn-fw" data-toggle="modal"
                            data-target="#upload">อัพโหลด</button>
                    </nav>
                    <div class="modal fade" id="upload" tabindex="-1" role="dialog" aria-labelledby="upload"
                        aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="upload">อัพโหลด
                                    </h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <form [formGroup]="uploadForm">
                                        <div class="col-12">
                                            <label>ปีงบประมาณ <b style="color: red;" *ngIf="!uploadForm.value.year"> *</b></label>
                                            <select class="form-control form-control-lg" formControlName="year"
                                                required>
                                                <option *ngFor="let year of fiscal_year" value="{{year}}">{{year}}
                                                </option>
                                            </select>
                                        </div><br>
                                        <div class="col-12">
                                            <label>ชื่อรายงาน <b style="color: red;" *ngIf="!uploadForm.value.pdf_name"> *</b></label>
                                            <input class="form-control form-control-lg" type="text" formControlName="pdf_name" required>
                                        </div>
                                        <br>
                                        <div class="col-12">
                                            เลือกไฟล์ <b style="color: red;" *ngIf="!uploadForm.value.pdf_file"> *</b>
                                            <input type="file" class="dropify" id="upload" formControlName="pdf_file"
                                                (change)="onFileSelect($event)" required />

                                        </div>
                                        <br>
                                        <div style="float: right;">
                                            <button type="submit" class="btn btn-gradient-success" data-dismiss="modal"
                                                [disabled]="!uploadForm.valid" (click)="onClickSave()">บันทึก</button>
                                            <button type="button" class="btn btn-gradient-light" data-dismiss="modal"
                                                style="margin-left: 10px;" (click)="onClose()">ยกเลิก</button>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-sm-12 grid-margin">
                        <div class="card" style="border-radius: 15px;" *ngIf="displayList">
                            <div class="card-body">
                                <div style="float: right;">
                                    <select class="form-control form-control-lg" id="exampleFormControlSelect1"
                                        style="width: 150px; height: 40px;" (change)="selectYear()" name="year_select"
                                        [(ngModel)]="year_select">
                                        <option [disabled]="true" value="">ค้นหาปีงบประมาณ</option>
                                        <option *ngFor="let year of years" value="{{year}}">{{year}}</option>
                                    </select>
                                </div>
                                <div class="table-responsive">
                                    <table class="table table-striped">
                                        <colgroup>
                                            <col style="width: 2%; text-align: center;">
                                            <col style="width: 15%;">
                                            <col style="width: 43%;">
                                            <col style="width: 20%;">
                                            <col style="width: 20%;">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th class="text-center"> </th>
                                                <th class="text-center"> ปีงบประมาณ </th>
                                                <th class="text-center"> ชื่อไฟล์ </th>
                                                <th class="text-center"> วันที่อัพโหลด</th>
                                                <th class="text-center"> </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let data of data_select| paginate : {
                                                itemsPerPage: tableSize,
                                                currentPage: page,
                                                totalItems: count
                                              };" style="cursor: pointer;">
                                                <td class="text-center"><i class="mdi mdi-file-document"></i></td>
                                                <td class="text-center">{{data.year}}</td>
                                                <td style="white-space: nowrap; 
                                                max-width: 30vw;
                                                overflow: hidden;
                                                text-overflow: ellipsis;" title="{{data.pdf_name}}">{{data.pdf_name}}</td>
                                                <td class="text-center">{{data.date_report}}</td>
                                                <td><button type="button"
                                                        class="btn btn-inverse-success btn-icon btn-sm"
                                                        (click)="onClickView(data.pdf_file, data.pdf_name)">
                                                        <i class="mdi mdi-eye"></i>
                                                    </button>
                                                    <button type="button" class="btn btn-inverse-info btn-icon btn-sm"
                                                        style="margin-left: 10px;"
                                                        (click)="onClickDownload(data.pdf_file, data.pdf_name)">
                                                        <i class="mdi mdi-download"></i>
                                                    </button>
                                                    <button type="button" class="btn btn-inverse-danger btn-icon btn-sm"
                                                        style="margin-left: 10px;"
                                                        (click)="onClickDelete(data)">
                                                        <i class="mdi mdi-delete-forever"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <pagination-controls previousLabel="ก่อนหน้า" nextLabel="ถัดไป" class="my-pagination"
                                (pageChange)="onTableDataChange($event)" style="text-align: center;">
                            </pagination-controls>
                        </div>
                        <div class="card" style="border-radius: 15px;" *ngIf="displayPdf">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-6 text-left" style="cursor:context-menu;">{{pdfName}}</div>
                                    <div class="col-6 text-right"><button type="button" class="btn btn-outline-success"
                                            (click)="onClickClose()">ย้อนกลับ</button></div>
                                </div>
                                <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block;"></pdf-viewer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>